import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

export function ImageLoadingSkeleton() {
    return (
        <>
            <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(0, 0, 0, 0.11)',
                    '&::after': {
                        background: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.06), transparent)'
                    }
                }}
            />
            <ImageOutlinedIcon
                sx={{
                    position: 'absolute',
                    zIndex: 1,
                    fontSize: 48,
                    color: 'rgba(0, 0, 0, 0.22)'
                }}
            />
        </>
    );
}
